module.exports = __webpack_public_path__ + "img/18.5d3a4455.png";